import { Row, Container, Button } from 'react-bootstrap'

import '../../../styles/homescreen/education.styles.scss'
import SubHeading from '../../subHeading/SubHeading'

const Education = () => {
  const actionLines = [
    {
      title: 'Procesos formativos y sensibilización',
      description: 'Impartimos talleres, charlas y seminarios en diversos entornos, incluyendo colegios, institutos, centros penitenciarios, organizaciones sindicales y empresas seleccionadas bajo criterios éticos.'
    },
    {
      title: 'Alfabetización corporal',
      description: 'Fomentamos que las niñas, mujeres y personas menstruantes aprendan a interpretar y registrar el lenguaje de su propio cuerpo a través de biomarcadores (como el moco cervical o la temperatura basal), reconociendo el ciclo como un indicador vital de salud ginecológica y endocrina.'
    },
    {
      title: 'Labor académica y profesionalización',
      description: 'Mantenemos una alianza con la Universitat de Barcelona, donde impartimos el Curso Superior Universitario en Educación Menstrual, con el fin de profesionalizar y dignificar la labor de las educadoras menstruales como agentes de transformación social.'
    },
    {
      title: 'Transformación de los imaginarios culturales',
      description: 'Aquellos que han construido la menstruación y la menopausia como procesos íntimos, vergonzantes y estigmatizados, para promover una cultura que los reconozca como experiencias biológicas diversas, dignas y libres de tabúes inferiorizantes.'
    },
    {
      title: 'Gestión menstrual saludable y digna',
      description: 'Educamos en el uso de productos que cuiden tanto el cuerpo como los ecosistemas, rechazando el enfoque meramente higienista y mercantilista.'
    }
  ]

  return (
    <Row className='education m-0 section__padding' id='education'>
      <Container className='education__container'>
        <Row className='d-flex flex-column mb-3 m-0'>
          <SubHeading title='Educación' color={true} />
        </Row>

        {/* Introducción */}
        <div className='education__introduction mb-5'>
          <p className='education__intro-text'>
            <strong>Como Asociación</strong> definimos nuestro trabajo en el ámbito de la educación como un enfoque pedagógico integral que busca transformar la percepción y vivencia de la menarquía, la pubertad, el ciclo ovárico y menstrual, el climaterio y la menopausia.
          </p>
          <p className='education__intro-text'>
            Nuestra labor educativa promueve una reflexión crítica feminista e interseccional sobre las etapas vitales desde la perspectiva de derechos humanos, justicia social y cuidado de la vida.
          </p>
        </div>

        {/* Líneas de acción */}
        <div className='education__lines-section mb-5'>
          <h3 className='education__lines-title'>Para cumplir con este objetivo, desarrollamos las siguientes líneas de acción:</h3>
          <div className='education__lines-container'>
            {actionLines.map((line, index) => (
              <div key={index} className='education__action-item'>
                <div className='education__action-number'>{index + 1}</div>
                <div className='education__action-content'>
                  <h4 className='education__action-title'>{line.title}</h4>
                  <p className='education__action-description'>{line.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Compromiso final */}
        <div className='education__commitment mb-5'>
          <p className='education__commitment-text'>
            Nuestro compromiso es garantizar que la <strong>educación menstrual sea reconocida como un derecho humano fundamental</strong>, asegurando que sea temprana, accesible, inclusiva y coeducativa para toda la sociedad. En el Estado español, este derecho está respaldado por la <strong>Ley Orgánica 1/2023</strong>.
          </p>
        </div>

        {/* CTA y botones */}
        <p className='normal-text text-center mt-5'>Consulta nuestra propuesta educativa</p>
        <div className='d-flex justify-content-center education__actions'>
          <Button href={`${process.env.PUBLIC_URL}/pdfs/propuesta_cast.pdf`} target='_blank'>
            CAST
          </Button>
          <Button href={`${process.env.PUBLIC_URL}/pdfs/propuesta_cat.pdf`} target='_blank' className='ml-3'>
            CAT
          </Button>
        </div>
      </Container>
    </Row>
  )
}

export default Education
